export const AuthActionTypes = {
    authorize: "@@triyo/auth/authorize",
    login: "@@triyo/auth/login",
    setJWT: "@@triyo/auth/setJWT",
}